export default "__VITE_ASSET__BUZMlqud__"